import 'angular:locale/data:en';
import '@angular/compiler';
import './src/polyfills.ts';
import '@angular/localize/init';(globalThis.$localize ??= {}).locale = "en";
